/**
 * Shared Sui client configuration.
 *
 * All browser RPC goes through the same-origin proxy /api/sui-rpc —
 * provider failover, rate limiting, and the login epoch cache live
 * server-side, and keyed endpoints never reach the public bundle.
 *
 * VITE_SUI_RPC_DEV_URL (dev builds only) points straight at a public
 * fullnode for `npm run dev`, where no /api functions are running.
 * Network is controlled by VITE_SUI_NETWORK (defaults to 'testnet').
 */
import { SuiClient } from '@mysten/sui.js/client';

export type SuiNetwork = 'mainnet' | 'testnet' | 'devnet' | 'localnet';

export const SUI_NETWORK: SuiNetwork =
  (import.meta.env.VITE_SUI_NETWORK as SuiNetwork) || 'testnet';

function getRpcUrl(): string {
  if (import.meta.env.DEV && import.meta.env.VITE_SUI_RPC_DEV_URL) {
    return import.meta.env.VITE_SUI_RPC_DEV_URL;
  }
  // Absolute URL — the SDK's transport is happier with one, and jsdom tests
  // resolve it the same way.
  return typeof window !== 'undefined'
    ? `${window.location.origin}/api/sui-rpc`
    : '/api/sui-rpc';
}

export const SUI_RPC_URL = getRpcUrl();

export const suiClient = new SuiClient({ url: SUI_RPC_URL });

export default suiClient;
